import Search, { ViewFilterType, SearchInitConfig, SearchClientConfig } from "../search";
import Utility from '../../classes/utility';
import { SearchEventHitsRendered, SearchEventTypes, SearchEventKeyUp, SearchEventNoResults } from "../utilities/search-events";

// Define FacetsRefinements interface for counting active filters
interface FacetsRefinements {
    [key: string]: string[];
}

interface PlaceholderAreaElements {
    placeholdertext: HTMLElement;
    placeholderH3: HTMLTitleElement;
    popularLinksContainer: HTMLElement;
    resultsContainer: HTMLElement;
}

interface OnLoadDebounce {
    hits?: number;
    currentHits?: number;
    lastState?: boolean;
    loadCount: number;
}

class MainSearch extends Search {
    mainSearchTrigger: HTMLElement;
    mainSearchTriggerScrolled: HTMLElement;
    mainContent: HTMLElement;
    mainSearchWrap: HTMLElement;
    mainCloseBtn: HTMLElement;
    mainHomepageInput: HTMLInputElement;
    mainHomepageBtn: HTMLElement;
    mainSearchResultsCount: HTMLElement;
    resultsElement: HTMLUListElement;
    titleElement: HTMLHeadingElement;
    onLoadDebounce: OnLoadDebounce;
    resetSearch: boolean = false;
    static placeholderText: string = "Start typing or browse some of our popular links!";

    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
        this.onLoadDebounce = {
            loadCount: 0
        };
    }

    private onLoadSearch() {
        this.init();
    }

    private onLoadViewFilters() {
        let self = this;
        self.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `filtersCategories-clearFilters`
        });
        this.addViewFilter({
            elementId: "ms-filter-categories",
            filterType: ViewFilterType.RefinementList,
            cssClasses : {
                input: "form-check-input",
                item: "form-check"
            }
        });
        this.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${this.initConfig.searchBoxId}-clear-filters`
        });
    }

    public static firstRenderFn(search: Search) {
        // set search input
        search.searchInput = document.querySelector('.ais-SearchBox-input');
        const h3 = document.querySelector(".main-search-results-count") as HTMLTitleElement;
        // on page load if a query set for this search?
        let query = Utility.getUrlParameter(search.initConfig.queryName);
        if (query) {
            if (h3) {
                h3.innerText = "Loading...";
            }

            search.searchInput.focus();
            search.setSearchBoxValue(query);

            MainSearch.viewAreasStatic(search.initConfig.placeholderId, search.initConfig.resultContainerId, true, true, false);
            // this.searchEvents.emit(SearchEventTypes.NoResults);
        } else {
            if (h3) {
                h3.innerText = MainSearch.placeholderText;
            }
            MainSearch.viewAreasStatic(search.initConfig.placeholderId, search.initConfig.resultContainerId, false, true, true);
        }
    }

    private onLoadViewUpdates() {
        // const clearFiltersElement = document.getElementById("filtersCategories-clearFilters");
        // if (clearFiltersElement) {
        //     clearFiltersElement.addEventListener("click", () => {
        //         const tagsContainer = document.querySelector(".search-tags");
        //         if (tagsContainer) {
        //             // clear visual tags
        //             const visualTags = tagsContainer.querySelectorAll('[id^="tag"]');
        //             if (visualTags) {
        //                 visualTags.forEach((tag) => {
        //                     tag.remove();
        //                 });
        //             }
        //         }
        //     });
        // }

        this.searchEvents.addListener(SearchEventTypes.NoResults, (eventData: SearchEventNoResults) => {
            var elss = this.viewAreas(true, false, false);
        });

        this.searchEvents.addListener(SearchEventTypes.KeyUp, (eventData: SearchEventKeyUp) => {
            // guard statement to deflect to no results
            if (eventData.count == 0) return;

            if (eventData.isEmpty) {
                var elss = this.viewAreas(false, true, true);
                elss.placeholderH3.innerText = MainSearch.placeholderText;
            } else {
                let elss = this.viewAreas(true, true, false);
                elss.placeholderH3.innerText = `${eventData.count} results`;
            }
        });

        this.searchEvents.addListener(SearchEventTypes.HitsRendered, (eventData: SearchEventHitsRendered) => {
            // guard statement to deflect to no results
            if (eventData.count == 0) return;
            let showPlaceholder = this.resetSearch? true : eventData.isFirstRender;
            const h3 = document.querySelector(".main-search-results-count") as HTMLTitleElement;

            // --- START DEBOUNCE --- //
            if (this.onLoadDebounce.lastState !== undefined) {
                // check for debounce
                if (this.onLoadDebounce.loadCount == 1 && this.onLoadDebounce.currentHits == eventData.currentHits.length &&
                        this.onLoadDebounce.hits == eventData.count && this.onLoadDebounce.lastState == true && 
                            eventData.isFirstRender == false) {
                    // console.log("debounce");
                    // if debounce, change state to true
                    eventData.isFirstRender = true;
                }
            }
            //create debounce for current hits on load
            this.onLoadDebounce.loadCount++;
            this.onLoadDebounce.currentHits = eventData.currentHits.length;
            this.onLoadDebounce.hits = eventData.count;
            this.onLoadDebounce.lastState = eventData.isFirstRender;
            // --- END DEBOUNCE --- //

            // if first render, check for query string
            if (eventData.isFirstRender) {
                let query = Utility.getUrlParameter(this.initConfig.queryName);
                if (query) {
                    // this is set here was on first load fn, result count is not set yet
                    if (h3) {
                        h3.innerText = `${eventData.count} results`;
                    }
                }
            } else {
                this.viewAreas(true, true, false);
                if (h3) {
                    h3.innerText = `${eventData.count} results`;
                }
            }
        });
    }

    override onLoad(facets: Array<any>) {
        //this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }

    init() {
        super.init();

        // self
        const self = this;

        // init main search items
        this.mainSearchTrigger = document.getElementById("mainSearchToggle");
        this.mainSearchTriggerScrolled = document.getElementById("mainSearchToggleScrolled");
        this.mainContent = document.querySelector(".page-content");
        this.mainSearchWrap = document.getElementById("mainSearchWrap");
        this.mainCloseBtn = document.querySelector('.close-search');
        this.mainHomepageInput = document.getElementById("mainsite-search-homepage-input") as HTMLInputElement;
        this.mainHomepageBtn = document.getElementById("mainsite-search-homepage-btn");
        this.mainSearchResultsCount = document.querySelector(".main-search-results-count");
        this.resultsElement = document.getElementById(this.initConfig.resultContainerId).querySelector('ul');
        this.titleElement = document.getElementById(this.initConfig.resultContainerId).querySelector('h4');

        // custom search for updating filter number on mobile button
        this.customSearch = function(helper) {
            let mobileFiltersButton = document.getElementById("mobile-filters-btn");
            if (mobileFiltersButton) {
                var filtersActiveCount: number = Object.values(this.search.helper.state.disjunctiveFacetsRefinements as FacetsRefinements)
                .reduce((acc: number, curr: Array<string>) => {
                    return acc + curr.length;
                }, 0);

                // if 0 display filters if not display filters (count)
                if (filtersActiveCount > 0) {
                    mobileFiltersButton.innerHTML = `Filters (${filtersActiveCount})`;
                } else {
                    mobileFiltersButton.innerHTML = `Filters`;
                }
            }
        };
        this.searchInput.focus();
    }

    public setTag(tagValue: string) {
        let cleanedValue = tagValue.replace("SAIT", '').trim();
        if(cleanedValue == "Document") {
            // document does not translate to PDFs
            cleanedValue = "PDFs";
        }
        const filter = document.getElementById("ms-filter-categories");
        const ul = filter.querySelector("ul"); 
        const findInput = async (ulElement: HTMLUListElement, value: string) => {
            const inputElements = await ulElement.getElementsByTagName('input');
            for await (let item of inputElements) {
                if (item.value.includes(value)) {
                    item.click();
                    return;
                }
            }
            return null;
        };
        findInput(ul, cleanedValue);
    }

    public viewAreas(resultsShow: boolean, headerTitleShow, popularLinkShow): PlaceholderAreaElements {
        return MainSearch.viewAreasStatic(this.initConfig.placeholderId, this.initConfig.resultContainerId, 
            resultsShow, headerTitleShow, popularLinkShow);
    }

    public static viewAreasStatic(placeholderId: string, resultContainerId: string, resultsShow: boolean, headerTitleShow, popularLinkShow): PlaceholderAreaElements {
        const placeholdertext: HTMLElement = document.getElementById(placeholderId);
        const resultsContainer: HTMLElement = document.getElementById(resultContainerId);
        const placeholderH3: HTMLTitleElement = document.querySelector(".main-search-results-count");
        const popularLinksContainer: HTMLElement = document.querySelector(".main-search-start-text");

        if (resultsShow) {
            resultsContainer.classList.remove("d-none");
        } else {
            resultsContainer.classList.add("d-none");
        }

        if (placeholderH3) {
            if (headerTitleShow) {
                placeholderH3.classList.remove("d-none");
            } else {
                placeholderH3.classList.add("d-none");
            }
        }

        if (popularLinkShow) {
            popularLinksContainer.classList.remove("d-none");
        } else {
            popularLinksContainer.classList.add("d-none");
        }

        return {
            placeholdertext: placeholdertext,
            placeholderH3: placeholderH3,
            popularLinksContainer: popularLinksContainer,
            resultsContainer: resultsContainer
        }
    }
}
export default MainSearch;